function addAdditionalPromiseMethods(promise, expect, subject) {
  promise.and = function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    function executeAnd() {
      if (expect.findTypeOf(args[0]).is('expect.it')) {
        return addAdditionalPromiseMethods(args[0](subject), expect, subject);
      } else {
        return expect.apply(void 0, [ subject ].concat( args ));
      }
    }

    if (this.isFulfilled()) {
      return executeAnd();
    } else {
      return addAdditionalPromiseMethods(
        this.then(executeAnd),
        expect,
        subject
      );
    }
  };

  return promise;
}

module.exports = addAdditionalPromiseMethods;
